export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/osago.5f00dbb6.svg","height":360,"width":462};